<template>
      <appbar-view></appbar-view>
    <div class="main-content">
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
      >
        {{ snackbar.message }}
      </v-snackbar>
      <v-snackbar
        v-model="snackbar2.show"
        :color="snackbar2.color"
        :timeout="3000"
      >
        {{ snackbar2.message }}
      </v-snackbar>
      <v-container>
      
        <!-- Boton de filtros -->

        <!-- Botón de filtros -->
        <v-row justify="end" class="mt-0 mb-2">
                <v-btn icon color="orange-darken-3" size="small" @click="toggleSearch">
            <v-icon>{{ showSearch ? "mdi-close" : "mdi-magnify" }}</v-icon>
          </v-btn>

          <v-text-field
            v-if="showSearch"
            ref="searchField"
            v-model="searchQuery"
            placeholder="Buscar productos"
            color="orange-darken-3"
            hide-details
            density="comfortable"
            class="ml-2"
            style="max-width: 260px"
          />

          <v-col cols="auto">
            <v-tooltip text="Filtrar y ordenar">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" color="blue-darken-4"
                  class="rounded-lg px-4 py-2 d-flex align-center" @click="dialogFiltro = true">
                  <v-icon class="mr-2" color="white">mdi-filter-variant</v-icon>
                  <span class="font-weight-medium text-caption text-uppercase text-white">
                    Filtrar
                  </span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>

        <!-- Filtro de precios menor que y mayor que -->
        <v-dialog v-model="dialogFiltro" max-width="420">
          <v-card class="rounded-lg" color="text-white">
            <v-card-title class="bg-blue-darken-4 text-white">
              <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
            </v-card-title>

            <v-card-text class="py-4">
              <v-switch
                v-model="sortByPrice"
                color="blue-darken-4"
                label="Ordenar por precio"
              >
                <template v-slot:label>
                  <v-icon small class="mr-1"></v-icon>
                  <div class="text-blue-darken-4"><strong> De menor a mayor</strong></div>
                </template>
              </v-switch>

              <v-select
                v-model="selectedBrands"
                :items="brands"
                label="Filtrar por Marca"
                multiple
                chips
                closable-chips
                variant="outlined"
                density="compact"
                color="blue-darken-4"
                class="mt-2"
              ></v-select>

              <v-select
                v-model="selectedPresentations"
                :items="presentations"
                label="Filtrar por Presentación"
                multiple
                chips
                closable-chips
                variant="outlined"
                density="compact"
                color="blue-darken-4"
              ></v-select>

              <v-btn
                color="#223b78"
                variant="flat"
                class="rounded-lg px-4 text-white"
                @click="applyFilters"
              >
                <v-icon class="mr-1">mdi-check</v-icon>
                Aplicar
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Carrusel de Marcas (Filtro Visual) -->
        <div v-if="brandList.length > 0" class="mb-2">
          <div class="d-flex overflow-x-auto pb-2 px-1" style="gap: 16px; scrollbar-width: none; -ms-overflow-style: none;">
            <div
              v-for="brand in brandList"
              :key="brand.name"
              class="d-flex flex-column align-center flex-shrink-0"
              style="cursor: pointer; width: 85px;"
              @click="toggleBrandFilter(brand.name)"
            >
              <v-avatar
                size="80"
                :style="selectedBrands.includes(brand.name) ? 'border: 3px solid #1565C0; padding: 10px;' : 'border: 1px solid #E0E0E0; background-color: white; padding: 10px;'"
              >
                <v-img :src="brand.image" :cover="false" style="height: 100%; width: 100%;"></v-img>
              </v-avatar>
              <span
                class="text-caption mt-1 text-center text-truncate w-100"
                style="font-weight: 500; line-height: 1.1;"
                :class="selectedBrands.includes(brand.name) ? 'text-blue-darken-4 font-weight-bold' : 'text-grey-darken-2'"
              >
                {{ brand.name }}
              </span>
            </div>
          </div>
        </div>

        <!-- Botón del carrito flotante -->
        <!-- Botón flotante Media Caja -->
        <v-btn
          icon
          class="floating-halfbox-btn"
          :color="viewHalfBoxes ? 'orange-darken-3' : 'white'"
          @click="toggleHalfBoxes"
          elevation="10"
        >
          <v-icon :color="viewHalfBoxes ? 'white' : 'grey-darken-3'" size="26">
            {{ viewHalfBoxes ? 'mdi-package-variant-closed' : 'mdi-puzzle' }}
          </v-icon>
        </v-btn>

  <!-- Boton de ver canasta  -->
        <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="openCart" elevation="10">
        <v-icon color="white" size="28">mdi-cart-outline</v-icon>
        <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
      </v-btn>
        <!-- Productos -->
        <!-- Productos -->
        <v-row dense>
          <v-col
            v-for="product in filteredProducts"
            :key="product.id"
            cols="6"
            sm="6"
            md="4"
            lg="3"
            class="d-flex justify-center"
          >
            <v-card class="pa-4" variant="flat" color="transparent" style="width: 240px">
              <v-row>
                <div class="d-flex align-center" style="position: relative">
                  <!-- Bloque de botones dinámicos -->
                  <div
                    v-if="getProductQuantity(getCartProduct(product)) > 0"
                    class="d-flex align-center mt-2"
                  >
                    <!-- Botón disminuir / eliminar -->
                    <v-btn
                      icon
                      @click="
                        (getProductQuantity(getCartProduct(product)) === 1 || viewHalfBoxes)
                          ? removeFromCart(getCartProduct(product))
                          : decreaseQuantity(getCartProduct(product))
                      "
                      variant="text"
                      density="compact"
                      :color="
                        (getProductQuantity(getCartProduct(product)) === 1 || viewHalfBoxes) ? 'red' : 'orange-darken-1'
                      "
                    >
                      <v-icon>
                        {{
                          (getProductQuantity(getCartProduct(product)) === 1 || viewHalfBoxes)
                            ? "mdi-delete"
                            : "mdi-minus-circle"
                        }}
                      </v-icon>
                    </v-btn>

                    <!-- Cantidad actual -->
                    <span
                      class="px-2 text-caption font-weight-bold"
                      style="font-size: 1.2em"
                    >
                      {{ getProductQuantity(getCartProduct(product)) }}
                    </span>

                    <!-- Botón aumentar -->
                    <v-btn
                      icon
                      size="42"
                      @click="viewHalfBoxes ? addPiecesToCart(product) : increaseQuantity(product)"
                      density="compact"
                      variant="text"
                      color="blue-darken-4"
                      :disabled="
                        product.id_promocion
                          ? getProductQuantity(getCartProduct(product)) >= 5
                          : false
                      "
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-row>

              <v-row class="d-flex justify-center" style="position: relative">
                <v-col cols="9" style="position: relative">
                  <!-- Imagen -->
                  <v-img
                    :src="product.foto || 'default-image-url'"
                    height="140"
                    class="rounded"
                    :cover="false"
                  />

                  <!-- Icono de agregar (Normal) -->
                  <template v-if="!viewHalfBoxes">
                  <v-icon
                    color="blue-darken-4"
                    size="42"
                    v-ripple
                    class="add-icon"
                    style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    "
                    :disabled="
                      product.id_promocion
                        ? getProductQuantity(getCartProduct(product)) >= 1 // 🔒 Si tiene promo, solo 1
                        : false
                    "
                    @click="
                      ((product.id_promocion && getProductQuantity(getCartProduct(product)) < 1) ||
                        (!product.id_promocion)) &&
                        addToCart(product)
                    "
                    :class="{
                      'v-icon--disabled': product.id_promocion
                        ? getProductQuantity(getCartProduct(product)) >= 1
                        : false,
                    }"
                    :style="
                      getProductQuantity(getCartProduct(product)) > 0
                        ? 'pointer-events: none; opacity: 0;'
                        : ''
                    "
                  >
                    mdi-plus-circle
                  </v-icon>
                  </template>

                  <!-- Botón PZA (Media Caja) -->
                  <template v-else>
                    <v-icon
                      color="blue-darken-4"
                      size="42"
                      v-ripple
                      class="add-icon"
                      style="
                        position: absolute;
                        top: 5px;
                        right: 5px;
                        background: white;
                        border-radius: 50%;
                        padding: 2px;
                        cursor: pointer;
                      "
                      @click="addPiecesToCart(product)"
                      :style="
                        getProductQuantity(getCartProduct(product)) > 0
                          ? 'pointer-events: none; opacity: 0;'
                          : ''
                      "
                    >
                      mdi-plus-circle
                    </v-icon>
                  </template>
                </v-col>
              </v-row>

              <!-- Precio / Promo -->
              <div
                class="w-full text-center mt-4 p-3 transition-shadow duration-300 space-y-1"
              >
                <template v-if="product.id_promocion && product.promo_price">
                  <div class="text-gray-500 line-through font-semibold">
                    ${{ product.price }}
                  </div>
                  <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                    ${{
                      (
                        product.price -
                        (product.price * product.promo_price) / 100
                      ).toFixed(2)
                    }}
                  </div>
                </template>
                <template v-else>
                  <div
                    class="text-base sm:text-lg md:text-xl font-semibold text-blue-700"
                  >
                    ${{ product.price }}
                  </div>
                </template>

                <!-- Nombre -->
                <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                  {{ product.nombre
                   }}
                </div>

                <!-- SKU -->
                <div class="text-xs sm:text-sm font-medium text-gray-400">
                  SKU: {{ product.sku }}
                </div>

                <div v-if="viewHalfBoxes" class="text-caption text-blue-darken-4 font-weight-bold mt-1">
                   Media Caja: {{ parseInt(product.PRODUC_PZAMINVTA || 0) }} Piezas
                </div>

                <!-- Distintivo de promoción -->
                <div
                  v-if="product.id_promocion && product.promo_price"
                  class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full"
                >
                  Descuento {{ product.promo_price }}%
                </div>

                <!-- Agotado -->
                <div
                  v-if="product.yfr_disponible <= 0"
                  class="text-sm sm:text-base font-semibold text-red-500"
                >
                  Agotado
                </div>

                <!-- Opción de venta por piezas (Media Caja) -->
       
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Diálogo del carrito -->
        <CartDialog v-model="cartDialog" />
      </v-container>
    </div>
      <bottom-navigation />
</template>


<script>
import AppbarView from "../appbar/appbarView.vue";
import BottomNavigation from "../submenu/BottomNavigation.vue";
import CartDialog from "../Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
import { inject, computed } from "vue";
import { ref, nextTick } from "vue";
import api from "@/services/api";
import { useUserStore } from "@/stores/userStore";

export default {
  name: "PeñafielView",
  components: { BottomNavigation, AppbarView, CartDialog },
  setup() {
    // Inyectar el store del carrito
     const userStore = useUserStore();
    const cartStore = inject("cartStore"); // Asegúrate de que 'cartStore' esté proporcionado globalmente
    const showSearch = ref(false);
    const searchQuery = ref("");
    const searchField = ref(null);

    // Usar los métodos del store global
    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const removeFromCart = cartStore.removeFromCart;
    const getProductQuantity = cartStore.getProductQuantity;
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });
    // Alternar búsqueda
    const toggleSearch = async () => {
      if (showSearch.value) {
        // Si ya está abierto, vaciar búsqueda y ocultar campo
        searchQuery.value = "";
        showSearch.value = false;
      } else {
        // Si estaba cerrado, mostrar campo y enfocar
        showSearch.value = true;
        await nextTick();
        searchField.value?.focus();
      }
    };

    // Ocultar búsqueda si pierde foco y está vacío
    const hideSearch = () => {
      if (!searchQuery.value.trim()) {
        showSearch.value = false;
      }
    };

    // Lógica para vender por piezas (Media Caja)
    const canSellPieces = (product) => {
      const conversion = parseFloat(product.PRODUC_FACTCONVER3 || 0);
      const minPieces = parseInt(product.PRODUC_PZAMINVTA || 0);
      // Verifica si es caja, tiene factor de conversión y mínimo de piezas válido
      // y si el mínimo de piezas es menor que la caja completa (ej. 4 < 8)
      return (
        ['CJA', 'CAJA'].includes(product.pround) &&
        conversion > 0 &&
        minPieces > 1 &&
        minPieces < conversion
      );
    };

    const addPiecesToCart = (product) => {
      const pieces = parseInt(product.PRODUC_PZAMINVTA);
      const conversion = parseFloat(product.PRODUC_FACTCONVER3);
      const piecePrice = product.price / conversion;

      // Crear producto derivado para piezas
      const pzaProduct = {
        ...product,
        id: product.id ? `${product.id}_PZA` : undefined,
        producto_id: product.producto_id ? `${product.producto_id}_PZA` : undefined,
        sku: `${product.sku}-PZA`,
        nombre: `${product.nombre} (${pieces} PZA)`,
        pround: 'PZA',
        price: piecePrice,
        foto: product.proveedor_desc1 || product.foto,
        yfr_disponible: (product.yfr_disponible || 0) * conversion,
        id_promocion: null,
        promo_price: null
      };

      // Agregar la cantidad mínima de piezas
      for (let i = 0; i < pieces; i++) {
        addToCart(pzaProduct);
      }
    };

    return {
      userStore, 
      showSearch,
      searchQuery,
      searchField,
      removeFromCart,
      addToCart, // Usar el método global para agregar al carrito
      increaseQuantity, // Usar el método global para aumentar la cantidad
      decreaseQuantity, // Usar el método global para disminuir la cantidad
      getProductQuantity,
      totalCajas,
      hideSearch,
      toggleSearch,
      canSellPieces,
      addPiecesToCart,
    };
  },
  data() {
    return {
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [], // Para múltiples valores
      selectedPresentations: [],
      presentations: [],
      selectedBrand: null,
      brandList: [],
      currentPage: 1,
      hasMoreProducts: true,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
      viewHalfBoxes: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      snackbar2: {
        show: false,
        message: "",
        color: "info",
      },
    };
  },
  computed: {
    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
          ? this.selectedBrands.includes(product.sublinea)
          : true;

        const matchesHalfBox = this.viewHalfBoxes ? this.canSellPieces(product) : true;

        const matchesPresentation = this.selectedPresentations.length > 0
          ? this.selectedPresentations.some(pres => product.nombre.toUpperCase().includes(pres))
          : true;

        return matchesSearch && matchesBrand && matchesHalfBox && matchesPresentation;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {
    updateBrandList() {
      const uniqueBrands = new Map();
      this.products.forEach(p => {
        if (p.sublinea && !uniqueBrands.has(p.sublinea)) {
          // Usamos la foto del producto como logo de la marca, o un fallback
          uniqueBrands.set(p.sublinea, p.foto || 'https://grupomv.mx/images/logo2.png');
        }
      });
      
      let list = Array.from(uniqueBrands, ([name, image]) => ({ name, image }));

      // 🔹 Define aquí el orden exacto que deseas (en mayúsculas)
      const customOrder = [
        "PENSAB",
        "CLAMAT",
        "SQUIRT",
        "DR PEPPER",
        "AGUA MINERAL",
        // Agrega más marcas aquí...
      ];

      list.sort((a, b) => {
        const indexA = customOrder.indexOf(a.name.toUpperCase());
        const indexB = customOrder.indexOf(b.name.toUpperCase());

        if (indexA !== -1 && indexB !== -1) return indexA - indexB; // Ambas en lista: usar tu orden
        if (indexA !== -1) return -1; // Solo A en lista: A va primero
        if (indexB !== -1) return 1;  // Solo B en lista: B va primero
        return a.name.localeCompare(b.name); // Ninguna en lista: orden alfabético
      });

      this.brandList = list;
    },
    toggleBrandFilter(brandName) {
      if (this.selectedBrands.includes(brandName)) {
        this.selectedBrands = [];
      } else {
        this.selectedBrands = [brandName];
      }
    },
    getCartProduct(product) {
      if (this.viewHalfBoxes) {
        return {
          ...product,
          id: product.id ? `${product.id}_PZA` : undefined,
          sku: `${product.sku}-PZA`,
        };
      }
      return product;
    },
    showNotification(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    toggleHalfBoxes() {
      this.viewHalfBoxes = !this.viewHalfBoxes;
      if (this.viewHalfBoxes) {
        this.snackbar2.message = "Modo Media Caja Activado";
        this.snackbar2.color = "info";
        this.snackbar2.show = true;
      } else {
        this.snackbar2.message = "Modo Caja Activado";
        this.snackbar2.color = "success";
        this.snackbar2.show = true;
      }
    },
    clearCart() {
      this.cart = []; // Vaciar el carrito
      localStorage.removeItem("cart"); // Limpiar el almacenamiento local
    },

    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },

    applyFilters() {
      this.dialogFiltro = false;
    },

    async fetchProducts(page = 1) {
  try {
    const limit = 250; // Número de productos por página
    const offset = (page - 1) * limit;
    const token = localStorage.getItem("token"); // ← obtener token

    // --- CACHE LOGIC ---
    const cacheKey = `products_101-bebidas_v2_${page}`;
    const cacheTimeKey = `products_101-bebidas_v2_${page}_time`;
    const now = Date.now();
    const cacheDuration = 15 * 60 * 1000; // 15 minutos

    const cachedData = localStorage.getItem(cacheKey);
    const cachedTime = localStorage.getItem(cacheTimeKey);

    if (cachedData && cachedTime && now - cachedTime < cacheDuration) {
      const parsed = JSON.parse(cachedData);

      this.products = [
        ...this.products,
        ...parsed.products.map(product => ({
          ...product,
          price: product.price || 0,
        })),
      ];

      this.hasMoreProducts = parsed.hasMore;
      this.brands = [...new Set(this.products.map(product => product.sublinea))];
      this.extractPresentations();
      this.updateBrandList();
      return;
    }

    // --- FETCH FROM API ---
    const response = await api.get(
      "https://mvexpress.mx/api/productos/101-adas-productos",
      {
        params: {
          limit,
          offset,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    const fetchedProducts = response.data.map(product => ({
      ...product,
      price: product.price || 0,
    }));

    this.products = [...this.products, ...fetchedProducts];
    this.hasMoreProducts = fetchedProducts.length >= limit;
    this.brands = [...new Set(this.products.map(product => product.sublinea))];
    this.extractPresentations();
    this.updateBrandList();

    // --- SAVE TO CACHE ---
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        products: fetchedProducts,
        hasMore: this.hasMoreProducts,
      })
    );
    localStorage.setItem(cacheTimeKey, now);

  } catch (error) {
    console.error("Error fetching products:", error.message);
  }
},

    extractPresentations() {
      const presentationSet = new Set();
      this.products.forEach(p => {
        if (!p.nombre) return;
        // Extraer tamaños como 600 ml, 2 L, 355ml, etc.
        const match = p.nombre.match(/(\d+(?:\.\d+)?\s*(?:ml|L|l|ML|oz))/i);
        if (match) {
          presentationSet.add(match[0].toUpperCase().replace(/\s+/g, ' '));
        }
      });
      this.presentations = [...presentationSet].sort((a, b) => 
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );
    },

    loadMoreProducts() {
      if (this.hasMoreProducts) {
        this.currentPage++;
        this.fetchProducts(this.currentPage);
      }
    },

suggestedProducts() {
  const token = this.userStore.token;
  if (!token) return;

  api
    .get("https://mvexpress.mx/api/productos/suggested-products", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => {
      if (Array.isArray(res.data)) this.suggestedItems = res.data;
    })
    .catch(err => console.error(err));
},

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY; // Posición actual del scroll
      const bottomPosition = document.documentElement.offsetHeight; // Altura total del documento

      // Si el usuario está cerca del final de la página, cargar más productos
      if (scrollPosition >= bottomPosition - 100 && this.hasMoreProducts) {
        this.loadMoreProducts();
      }
    },
  },
mounted() {
  // 👤 Usuario desde userStore
  if (!this.userStore.isAuthenticated) {
    console.error("Usuario no autenticado. Redirigiendo a login...");
    this.$router.replace("/login");
    return;
  }

  // Asignar usuario local para plantilla
  this.user = this.userStore.user;

  // Direcciones desde userStore
  this.direcciones = this.userStore.user?.direcciones ?? [];

  // Cargar productos y sugeridos
  this.fetchProducts();
  this.suggestedProducts();

  // Cargar carrito
  const saveCart = localStorage.getItem("cart");
  if (saveCart) this.cart = JSON.parse(saveCart);

  window.addEventListener("scroll", this.handleScroll);
},

beforeUnmount() {
  window.removeEventListener("scroll", this.handleScroll);
}

};
</script>


<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}
.main-content {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  padding-bottom: calc(env(safe-area-inset-bottom) + 220px) !important;
}
.floating-cart-btn {
  position: fixed;
  bottom: 150px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}
.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.floating-halfbox-btn {
  position: fixed;
  bottom: 220px; /* Ajustado para estar arriba del carrito (150px + 60px + gap) */
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}

</style>